import React from 'react'
import { motion } from 'framer-motion'
import { Backend_skill, Frontend_skill, Full_stack, Other_skill } from '../data/alldata'
import SkillDataProvider from './Item/SkillDataProvider'
import StarsCanvas from '../3d/Stars';
const Skills = () => {
  const textVariant = () => {
    return {
      hidden: { opacity: 0, y: -50 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
    };
  };
  
  const fadeIn = (direction = "", type = "spring", delay = 0.1, duration = 1) => {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { delay, duration } },
    };
  };
  return (
    <>
    

    <div
    className="relative w-full h-auto mx-auto  bg-center"
id='skills'
>
 
      <motion.div
 initial={{opacity:0.2,y:50}}
      transition={{duration:1}}
      whileInView={{opacity:1,y:0}}
      viewport={{once:true}}
  className="flex flex-col items-center justify-center text-center"
>
  
  <h2 className="text-black text-[69px] font-bold">Skills &<span className="text-[#fff000]"> Technologies</span></h2>
  <p className='text-gray-500 text-center text-[18px] font-normal'>I have experience working with a wide range of technologies and tools. Here are a few of my favorites.</p>
</motion.div>


<section style={{transform:'scale(0.9)'}} className='flex flex-col items-center justify-center gap-3 h-full relative overflow-hidden '>
<div className="flex flex-row justify-around flex-wrap mt-4 gap-5 items-center cursor-pointer">
 
  {Frontend_skill.map((image,index)=>(

   <SkillDataProvider
   key={index}
   src={image.Image}
   width={image.width}
   height={image.height}
   index={index}
   
   
   
   />
  ))}
  </div>
  <div className="flex flex-row justify-around flex-wrap mt-4 gap-5 items-center cursor-pointer">
 
  {Backend_skill.map((image,index)=>(

   <SkillDataProvider
   key={index}
   src={image.Image}
   width={image.width}
   height={image.height}
   index={index}
   
   
   
   />
  ))}
  </div>
  <div className="flex flex-row justify-around flex-wrap mt-4 gap-5 items-center cursor-pointer">
 
  {Full_stack.map((image,index)=>(

   <SkillDataProvider
   key={index}
   src={image.Image}
   width={image.width}
   height={image.height}
   index={index}
   
   
   
   />
  ))}
  </div>
  <div className="flex flex-row justify-around flex-wrap mt-4 gap-5 items-center cursor-pointer">
 
  {Other_skill.map((image,index)=>(

   <SkillDataProvider
   key={index}
   src={image.Image}
   width={image.width}
   height={image.height}
   index={index}
   
   
   
   />
  ))}
  </div>
  <div className="w-full h-full absolute">
    <div className="w-full h-full z-[-10] opacity-30 absolute flex items-center justify-center bg-cover">
      {/* <video
      className='w-full h-auto'
      preload='false'
      playsInline
      loop
      muted
      autoPlay
      src='./cards-video.webm'
      /> */}
    </div>

  </div>


</section>
  </div>

</>
  )
}

export default Skills